export const disableAroundFields = (
  array: string[],
  ignoreFields: string[],
  currentState: any,
  currentField: string
) => {
  const index = array.indexOf(currentField)
  const newState = JSON.parse(JSON.stringify(currentState))
  if (!currentField) return currentState

  array.forEach((item: any) => {
    if (ignoreFields.includes(item)) return (newState[item].disabled = false)
    if (index === currentState[item].position)
      return (newState[item].disabled = false)
    return (newState[item].disabled = true)
  })

  return newState
}
